<div class="top-banks">
  <div *ngFor="let key of getBankNames(topBank); let i = index" class="bank-icons">
    <button type="button" [class]="key" (click)="selectTopBank(key)" [ngClass]="{'active':banksName.value==key}" [disabled]="vars.isOrderLoading" mat-stroked-button>
    </button>
    <div>{{topBank[key]}}</div>
  </div>
</div>

<div class="bank-dropdown">
  <form [formGroup]="netBankForm" (ngSubmit)="submitTopBank()">
    <mat-form-field>
      <mat-select [formControl]="banksName" placeholder="Select Bank" (openedChange)="resetSearch()" [disabled]="vars.isOrderLoading">
        <app-input class="search-input" inputType="text" [control]="searchText" [group]="searchForm" placeHolder="Search"
                    (OnChange)="search($event)">
        </app-input>
        <mat-option *ngFor="let key of getBankNames(option)" [value]="key" class="bankDropdownList">
          {{option[key]}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div *ngIf="paymentUtilService.utmProceedClicked">
      <app-utm-wallet-hundred type="payment" [donation]="cartDetails?.donated_amount"></app-utm-wallet-hundred>
    </div>
    <app-donate-btn label="proceed to contribute" [btnClass]="'submit-payment'" [amount]="cartDetails?.donated_amount" [isOrderLoading]="isOrderLoading || vars.isOrderLoading"></app-donate-btn>
  </form>
</div>
